import styled from 'styled-components';

import { Text } from '~/components/ui/Text';

const StyledTextLabel = styled(Text)`
	color: #ffffff;
	font-size: 16px;
	font-weight: 500;
	transition: color 0.3s ease;
	pointer-events: none;
`;

const StyledContainer = styled.div`
	&:hover {
		img {
			opacity: 1;
		}
	}
`;

const StyledButtonContent = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: space-between;

	img {
		opacity: 0.5;
	}
`;

export { StyledButtonContent, StyledContainer, StyledTextLabel };
